import Vue from 'vue'

import Vuex from 'vuex'
import axios from 'axios'

import router from '../router'

import locationsMex from '../constants/locations-mex.json'
import locationsPer from '../constants/locations-per.json'
import locationsSpa from '../constants/locations-spa.json'
import locationsUsa from '../constants/locations-usa.json'

Vue.use(Vuex)

const theNow = new Date().toJSON().split('T')[0]

// function to get initial state
const getDefaultState = () => {
  return {
    idToken: localStorage.getItem('id_token') || null,
    accessToken: localStorage.getItem('access_token') || null,
    expirationDate: localStorage.getItem('expiration_date') || null,
    isLoading: false,
    status: '',
    hasLoadedOnce: false,

    me: { localUser: null, company: '', fullname: '', email: '', idCompany: null },
    wizardStep: 0,
    filter: {
      shows: {
        annual_turnover: false,
        version: false,
        city: false,
        sector: false,
        kindOfPerson: false,
        dateRegistry: false,
        total: false
      },
      opts: {
        annual_turnover: {
          amount: {
            show: false, key: '0'
          }
        },
        version: {
          colombia: {
            show: false, key: 'colombia'
          },
          costaRica: {
            show: false, key: 'costaRica'
          },
          mexico: {
            show: false, key: 'mexico'
          },
          spain: {
            show: false, key: 'spain'
          },
          peru: {
            show: false, key: 'peru'
          },
          panama: {
            show: false, key: 'panama'
          },
          chile: {
            show: false, key: 'chile'
          },
          republicaDominicana: {
            show: false, key: 'republicaDominicana'
          },
          usa: {
            show: false, key: 'usa'
          },
          argentina: {
            show: false, key: 'argentina'
          },
          other: {
            show: false, key: 'other' // international
          }
        },
        sector: {
          agricultureLivestock: {
            show: false, key: 'Agricultura / Ganadería'
          },
          foodGastronomy: {
            show: false, key: 'Alimentación / Gastronomía'
          },
          architectureConstruction: {
            show: false, key: 'Arquitectura / Construcción'
          },
          artsCrafts: {
            show: false, key: 'Artes / Manualidades'
          },
          automotiveAndParts: {
            show: false, key: 'Automotores y partes'
          },
          detalTrading: {
            show: false, key: 'Comercio al detal'
          },
          retail: {
            show: false, key: 'Comercio al detalle'
          },
          electronicCommerce: {
            show: false, key: 'Comercio electrónico'
          },
          consulting: {
            show: false, key: 'Consultoría'
          },
          personalCareAestheticsHealth: {
            show: false, key: 'Cuidado personal / Estética / Salud'
          },
          education: {
            show: false, key: 'Educación'
          },
          entertainment: {
            show: false, key: 'Entretenimiento'
          },
          hospitalityTourism: {
            show: false, key: 'Hotelería / Turismo'
          },
          realEstate: {
            show: false, key: 'Inmobiliario'
          },
          manufacturing: {
            show: false, key: 'Manufactura'
          },
          nonGovernmentalOrganization: {
            show: false, key: 'Organización no gubernamental'
          },
          advertisingDigitalMedia: {
            show: false, key: 'Publicidad / Medios digitales'
          },
          financialAccountingServices: {
            show: false, key: 'Servicios contables o financieros'
          },
          specializedServices: {
            show: false, key: 'Servicios especializados'
          },
          technologyTelecommunications: {
            show: false, key: 'Tecnología / Telecomunicaciones'
          },
          transportLogistics: {
            show: false, key: 'Transporte / Logística'
          },
          others: {
            show: false, key: 'Otros'
          }
        },
        kindOfPerson: {
          legal: {
            show: false, key: '1'
          },
          natural: {
            show: false, key: '2'
          }
        },
        dateRegistry: {
          from: {
            show: true, key: '2012-01-01'
          },
          to: {
            show: true, key: theNow
          }
        },
        total: {
          from: {
            show: true, key: 0
          },
          to: {
            show: true, key: '*'
          }
        },
        time: {
          months: {
            show: true, key: ''
          }
        }
      }
    },
    aqlFilter: {
      version: null,
      sector: null,
      kindOfPerson: null,
      dateRegistry: null,
      total: null,
      currency: null
    },
    leads: {
      users: {
        already: [],
        maybe: {
          total: 0,
          bySector: { '': 1 },
          byCity: { '': 1 },
          byAntiquity: { '': 1 },
          byMonthlyBilling: { '': 1 },
          isThereNewData: false,
          backgroundColor: '#eaedf74c'
        }
      },
      opts: []
    },
    prospectsFilter: {
      localBatchesPurchase: [],
      statuses: [],
      name: ''
    },
    batchesPurchase: [],
    alreadyusersFirstLoad: {
      status: false,
      length: 0
    },
    dashboardData: null,
    cities: [],
    leadsSearchMsgError: '',
    leadCreatedMsg: ''
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    loading (state, status) {
      state.isLoading = status
    },
    authRequest (state) {
      state.status = 'loading'
    },
    authMe (state, { idToken, accessToken, expirationDate }) {
      state.idToken = idToken
      state.accessToken = accessToken
      state.expirationDate = expirationDate
      state.status = 'success'
      state.hasLoadedOnce = true
    },
    authError (state) {
      state.status = 'error'
      state.hasLoadedOnce = true
    },
    clearAuthData (state) {
      state.idToken = null
      state.accessToken = null
      state.isLoading = false
      state.status = ''
      state.hasLoadedOnce = false
    },
    storeMe (state, me) {
      state.me = me
    },
    maybeUsers (state, users) {
      state.leads.users.maybe = users
    },
    alreadyUsers (state, users) {
      state.leads.users.already = users
    },
    filter (state, { filter }) {
      state.filter = filter
    },
    aqlFilter (state, { aqlFilter }) {
      state.aqlFilter = aqlFilter
    },
    batchesPurchase (state, batchesPurchase) {
      state.batchesPurchase = batchesPurchase
    },
    prospectsFilter (state, { localBatchesPurchase, statuses, name }) {
      state.prospectsFilter = {
        localBatchesPurchase,
        statuses,
        name
      }
    },
    leadStatuses (state, { localLead, status, observation }) {
      const statusKeys = {
        skip: 'non-applicable',
        study: 'in-study',
        approve: 'approved',
        reject: 'rejected',
        payed: 'payed'
      }
      state.leads.users.already.map(el => {
        if (el.idLocal === localLead) {
          el.status = statusKeys[status]
          el.observation = observation
        }
      })
    },
    disbursement (state, { localLead, amount }) {
      state.leads.users.already.map(el => {
        if (el.idLocal === localLead) {
          el.amount = amount
        }
      })
    },
    alreadyusersFirstLoad (state, { status, length }) {
      state.alreadyusersFirstLoad = {
        status,
        length
      }
    },
    dashboardData (state, { data }) {
      state.dashboardData = data
    },
    cities (state, cities) {
      state.cities = cities
    },
    leadsSearchMsgError (state, msg) {
      state.leadsSearchMsgError = msg
    },
    leadCreatedMsg (state, msg) {
      state.leadCreatedMsg = msg
    },
    /**
     * Wizard
     */
    goToNextStep (state) {
      if (state.wizardStep < 4) {
        state.wizardStep++
      }
    },
    goToPrevStep (state) {
      if (state.wizardStep > 0) {
        state.wizardStep--
      }
    },
    finalStepReset (state) {
      const { wizardStep, filter, leads: { users: { maybe } } } = getDefaultState()
      state.wizardStep = wizardStep
      state.filter = filter
      state.leads.users.maybe = maybe
    },
    noFinalStepReset (state) {
      const { wizardStep } = getDefaultState()
      state.wizardStep = wizardStep
    },
    fullReset (state) {
      state = getDefaultState()
    }
  },
  actions: {
    setLogoutTimer ({ commit }, millis) {
      setTimeout(() => {
        commit('clearAuthData')
      }, millis)
    },
    login ({ commit, dispatch }, { email, password }) {
      const token = Buffer.from(`${email}:${password}`, 'utf8').toString('base64')

      commit('authRequest')
      axios.post('/auth/login', {}, {
        headers: {
          Authorization: `Basic=${token}`
        }
      })
        .then(res => {
          const { access_token: accessToken, expires_in: expiresIn, id_token: idToken } = res.data
          const expirationDate = Date.now() + expiresIn * 1000

          localStorage.setItem('access_token', accessToken)
          localStorage.setItem('expiration_date', expirationDate)
          localStorage.setItem('id_token', idToken)

          axios.defaults.headers.common.Authorization = `Bearer ${idToken}`

          commit('authMe', { idToken, accessToken, expirationDate })
          dispatch('fetchMe')
        })
        .catch(e => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('expiration_date')
          localStorage.removeItem('id_token')
          commit('clearAuthData')
          commit('authError')
          console.log(e)
        })
        .finally(() => {
          router.replace('/')
        })
    },
    tryAutoLogin ({ commit, dispatch, getters }) {
      if (!getters.isAuthenticated) {
        commit('clearAuthData')
        localStorage.removeItem('access_token')
        localStorage.removeItem('expiration_date')
        localStorage.removeItem('id_token')
        return null
      }
      dispatch('fetchMe')
    },
    logout ({ commit }) {
      commit('clearAuthData')
      localStorage.removeItem('access_token')
      localStorage.removeItem('expiration_date')
      localStorage.removeItem('id_token')
      router.replace('/login')
    },
    fetchMe ({ commit, dispatch, state }) {
      if (!state.idToken && !state.accessToken) {
        return null
      }
      commit('loading', true)
      axios.post('/auth/userinfo', {
        accessToken: state.accessToken
      })
        .then(res => {
          const me = res.data.me
          commit('storeMe', me)
          dispatch('alreadyUsers')
        })
        .catch(err => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('expiration_date')
          localStorage.removeItem('id_token')
          commit('clearAuthData')
          router.replace('login')
          console.log(err)
        })
    },
    aqlFilter ({ commit, state }, { aqlFilter, wasMonthlyBillingrequested }) {
      commit('loading', true)
      commit('leadsSearchMsgError', '')

      axios.post('/alegra/search', { ...aqlFilter, wasMonthlyBillingrequested })
        .then(({ data: { maybeUsers } }) => {
          if (maybeUsers) {
            commit('aqlFilter', { aqlFilter: { ...state.aqlFilter, ...aqlFilter } })
            /*
            if (wasMonthlyBillingrequested) {
              const { byMonthlyBilling, total } = maybeUsers
              commit('maybeUsers', { ...state.leads.users.maybe, byMonthlyBilling, total, isThereNewData: true })
            } else {
              const { bySector, byCity, byAntiquity, total } = maybeUsers
              commit('maybeUsers', { ...state.leads.users.maybe, bySector, byCity, byAntiquity, total, isThereNewData: true })
            }
            */
            return maybeUsers
          }
        })
        .then(async maybeUsers => {
          const { byMonthlyBilling, byCity, bySector, byAntiquity } = maybeUsers

          const requestConfigs = []

          let time

          for (time = 1; time <= maybeUsers.times; time++) {
            requestConfigs.push({
              method: 'POST',
              url: '/alegra/search',
              data: { ...aqlFilter, requestNumber: time, wasMonthlyBillingrequested }
            })
          }

          Promise.all(requestConfigs.map(async config => await axios(config).catch(err => { console.log(err.message); commit('loading', false) }))).then(results => {
            results.map(({ data: { maybeUsers: nextMaybeUsers } }, index, arr) => {
              const { byMonthlyBilling: nextByMonthlyBilling, byCity: nextByCity, bySector: nextBySector, byAntiquity: nextByAntiquity } = nextMaybeUsers

              const nextByMonthlyBillingLabels = Object.keys(nextByMonthlyBilling)
              const nextByCityLabels = Object.keys(nextByCity)
              const nextBySectorLabels = Object.keys(nextBySector)
              const nextByAntiquityLabels = Object.keys(nextByAntiquity)

              for (const label of nextByMonthlyBillingLabels) {
                const value = byMonthlyBilling[`${label}`]
                if (value) {
                  if (value.length) {
                    byMonthlyBilling[`${label}`] = value.concat([nextByMonthlyBilling[`${label}`]])
                  } else {
                    byMonthlyBilling[`${label}`] = [value, nextByMonthlyBilling[`${label}`]]
                  }

                  if (index + 1 === maybeUsers.times) {
                    const finalValues = byMonthlyBilling[`${label}`]
                    byMonthlyBilling[`${label}`] = Math.round(100 * finalValues.reduce((accumulator, currentValue) => accumulator + currentValue) / finalValues.length) / 100
                  }
                } else {
                  byMonthlyBilling[`${label}`] = nextByMonthlyBilling[`${label}`]
                }
              }

              for (const label of nextByCityLabels) {
                const value = byCity[`${label}`]
                if (value) {
                  if (value.length) {
                    byCity[`${label}`] = value.concat([nextByCity[`${label}`]])
                  } else {
                    byCity[`${label}`] = [value, nextByCity[`${label}`]]
                  }

                  if (index + 1 === maybeUsers.times) {
                    const finalValues = byCity[`${label}`]
                    byCity[`${label}`] = Math.round(100 * finalValues.reduce((accumulator, currentValue) => accumulator + currentValue) / finalValues.length) / 100
                  }
                } else {
                  byCity[`${label}`] = nextByCity[`${label}`]
                }
              }

              for (const label of nextBySectorLabels) {
                const value = bySector[`${label}`]
                if (value) {
                  if (value.length) {
                    bySector[`${label}`] = value.concat([nextBySector[`${label}`]])
                  } else {
                    bySector[`${label}`] = [value, nextBySector[`${label}`]]
                  }

                  if (index + 1 === maybeUsers.times) {
                    const finalValues = bySector[`${label}`]
                    bySector[`${label}`] = Math.round(100 * finalValues.reduce((accumulator, currentValue) => accumulator + currentValue) / finalValues.length) / 100
                  }
                } else {
                  bySector[`${label}`] = nextBySector[`${label}`]
                }
              }

              for (const label of nextByAntiquityLabels) {
                const value = byAntiquity[`${label}`]
                if (value) {
                  if (value.length) {
                    byAntiquity[`${label}`] = value.concat([nextByAntiquity[`${label}`]])
                  } else {
                    byAntiquity[`${label}`] = [value, nextByAntiquity[`${label}`]]
                  }

                  if (index + 1 === maybeUsers.times) {
                    const finalValues = byAntiquity[`${label}`]
                    byAntiquity[`${label}`] = Math.round(100 * finalValues.reduce((accumulator, currentValue) => accumulator + currentValue) / finalValues.length) / 100
                  }
                } else {
                  byAntiquity[`${label}`] = nextByAntiquity[`${label}`]
                }
              }
            })
          })
            .then(() => {
              const finalMaybeUsers = { byMonthlyBilling, byCity, bySector, byAntiquity }

              if (wasMonthlyBillingrequested) {
                const { byMonthlyBilling, total } = finalMaybeUsers
                commit('maybeUsers', { ...state.leads.users.maybe, byMonthlyBilling, total, isThereNewData: true })
              } else {
                const { bySector, byCity, byAntiquity, total } = finalMaybeUsers
                commit('maybeUsers', { ...state.leads.users.maybe, bySector, byCity, byAntiquity, total, isThereNewData: true })
              }
            })
            .catch(err => {
              console.log(err.message)
              commit('leadsSearchMsgError', 'Upps! Ocurrió un problema. Por favor inténtelo de nuevo')
            })
            .finally(() => {
              commit('loading', false)
            })
        })
        .catch(err => {
          console.log(err.message)
          commit('loading', false)
          commit('leadsSearchMsgError', 'Upps! Ocurrió un problema. Por favor inténtelo de nuevo')
        })
    },
    batchesPurchase ({ commit, dispatch, state }) {
      const { aqlFilter } = state
      commit('loading', true)

      axios.post('/batch-purchases/create', {
        filter: aqlFilter,
        message: 'Default message',
        subject: 'Tenemos una excelente noticia para ti',
        isDefault: true,
        idCompany: state.me.idCompany,
        localUser: state.me.localUser
      })
        .then(res => {
          const { data: { localBatchesPurchase } } = res
          dispatch('notification', { localBatchesPurchase, filter: aqlFilter })
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          commit('loading', false)
          commit('goToNextStep')
        })
    },
    notification ({ commit, state }, { localBatchesPurchase, filter }) {
      const { me: { localUser, idCompany, company, email, fullname } } = state
      commit('loading', true)

      axios.post('/notification/send', {
        company,
        fullname,
        email,
        idCompany,
        localUser,
        localBatchesPurchase,
        filter
      })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          commit('loading', false)
          commit('goToNextStep')
        })
    },
    alreadyUsers ({ commit, dispatch, state }) {
      commit('loading', true)
      const { me: { localUser, idCompany }, prospectsFilter: { localBatchesPurchase, statuses, name }, alreadyusersFirstLoad } = state
      const params = {}

      if (localUser || localUser === 0) { params.localUser = localUser }
      if (idCompany) { params.idCompany = idCompany }
      if (name) { params.name = name }
      if (localBatchesPurchase.length) { params.localBatchesPurchase = localBatchesPurchase.join() }
      if (statuses.length) { params.statuses = statuses.join() }

      axios.get('/lead/list', {
        params
      })
        .then(res => {
          const { leads } = res.data

          return leads
        })
        .then(alreadyUsers => {
          alreadyUsers.map(el => {
            el.data = JSON.parse(el.data)
          })
          commit('alreadyUsers', alreadyUsers)
          if (!alreadyusersFirstLoad.status) {
            commit('alreadyusersFirstLoad', { status: true, length: alreadyUsers.length })
          }
          commit('loading', false)
          if (localBatchesPurchase.length === 0) {
            dispatch('listBatchesPurchase')
          }
        })
        .catch(err => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('expiration_date')
          localStorage.removeItem('id_token')
          commit('clearAuthData')
          router.replace('login')
          console.log(err)
        })
    },
    leadStatuses ({ commit, dispatch, state }, { localLead, status, observation, amount }) {
      axios.post(`/lead/${localLead}/${status}`, {
        idCompany: state.me.idCompany,
        observation
      })
        .then(res => {
          commit('leadStatuses', { localLead, status, observation })
          if (status === 'payed') {
            dispatch('disbursement', { localLead, amount })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCities ({ commit, dispatch, state }, country) {
      if (['mexico', 'peru', 'usa', 'spain', 'other'].includes(country)) {
        let locations

        if (country === 'mexico') {
          locations = locationsMex
        } else if (country === 'peru') {
          locations = locationsPer
        } else if (country === 'usa') {
          locations = locationsUsa
        } else if (country === 'spain') {
          locations = locationsSpa
        } else if (country === 'other') {
          commit('cities', [])
          return
        }

        const cities = locations.map(({ city, id }) => {
          return {
            text: city,
            value: id
          }
        })

        commit('cities', cities)
      } else {
        axios({
          method: 'get',
          url: `https://config.alegra.com/api/v1/cities?application_version=${country}`
        })
          .then(({ data: cities }) => {
            return cities.map(city => {
              return {
                text: city.value,
                value: city.id // + `${Math.random() * Math.random() * Date.now()}`
              }
            })
          })
          .then(cities => commit('cities', cities))
          .catch(err => {
            console.log(err.message)
            commit('cities', [])
          })
      }
    },
    checkLead ({ commit, dispatch, state }, token) {
      commit('loading', true)

      axios.post('/alegra/checkLead', { token })
        .catch(e => {
          console.log(e.message)
          router.replace('/notFound')
        })
        .finally(() => commit('loading', false))
    },
    leadAdded ({ commit }, { token, fullname, fintech, email, mobile }) {
      commit('loading', true)
      commit('leadCreatedMsg', '')

      axios.post('/lead/create', {
        token,
        fullname,
        fintech,
        email,
        mobile
      })
        .then(() => {
          commit('leadCreatedMsg', '¡Los datos fueron enviados con éxito!')
        })
        .catch(e => {
          console.log(e.message)
          router.replace('/notFound')
        })
        .finally(() => commit('loading', false))
    },
    listBatchesPurchase ({ commit, state }) {
      axios.get('/batch-purchases/list', {
        params: {
          id: state.me.idCompany
        }
      })
        .then(({ data: { batches } }) => {
          batches.map(el => {
            const [year, month, day] = el.createdAt.split('T')[0].split('-')
            el.createdAt = `${day}/${month}/${year}`
            el.isConsidered = true
          })
          commit('batchesPurchase', batches)
        })
        .catch(err => {
          console.log(err)
        })
    },
    disbursement ({ commit, state }, { localLead, amount }) {
      axios.post('/disbursement/create', {
        idCompany: state.me.idCompany,
        localLead,
        amount
      })
        .then(res => {
          commit('disbursement', { localLead, amount })
        })
        .catch(err => {
          console.log(err)
        })
    },
    finalStepReset ({ commit }, path) {
      commit('finalStepReset')
      router.replace(path)
    },
    noFinalStepReset ({ commit, getters }, path) {
      commit('noFinalStepReset')
      router.replace(path)
    }
  },
  modules: {
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    status (state) {
      return state.status
    },
    me (state) {
      return state.me
    },
    isAuthenticated (state) {
      const { idToken, accessToken, expirationDate } = state
      const now = Date.now()

      return (idToken && accessToken && (expirationDate > now)) === true
    },
    leads (state) {
      return state.leads
    },
    alreadyUsers (state) {
      return state.leads.users.already
    },
    maybeUsers (state) {
      return state.leads.users.maybe
    },
    aqlFilter (state) {
      return state.aqlFilter
    },
    filter (state) {
      return state.filter
    },
    isFilterActive (state) {
      const { dateRegistry, total } = state.filter.shows
      const { version, sector, kindOfPerson } = state.filter.opts

      function isThereTrueOpts (opts) {
        return Object.values(opts).filter(el => el.show).length
      }

      return isThereTrueOpts(version) + isThereTrueOpts(sector) + isThereTrueOpts(kindOfPerson) !== 0 || dateRegistry || total
    },
    prospectsFilter (state) {
      return state.prospectsFilter
    },
    batchesPurchase (state) {
      return state.batchesPurchase
    },
    alreadyusersFirstLoad (state) {
      return state.alreadyusersFirstLoad
    },
    initialState () {
      return getDefaultState()
    },
    dashboardData (state) {
      return state.dashboardData
    },
    cities (state) {
      return state.cities
    },
    leadsSearchMsgError (state) {
      return state.leadsSearchMsgError
    },
    leadCreatedMsg (state) {
      return state.leadCreatedMsg
    },
    /**
     * Wizard
     */
    isZeroStep (state) {
      return state.wizardStep === 0
    },
    isFirstStep (state) {
      return state.wizardStep === 1 // filters
    },
    isSecondStep (state) {
      return state.wizardStep === 2 // email
    },
    isThirdStep (state) {
      return state.wizardStep === 3 // resume
    },
    isFourthStep (state) {
      return state.wizardStep === 4 // payment
    },
    isFifthStep (state) {
      return state.wizardStep === 5 // sended
    },
    isFirstToFourthStep (state) {
      return state.wizardStep > 0 && state.wizardStep < 5
    },
    isFirstToFifthStep (state) {
      return state.wizardStep > 0 && state.wizardStep < 6
    },
    isSecondToFourthStep (state) {
      return state.wizardStep > 1 && state.wizardStep < 5
    },
    isSecondToFifthStep (state) {
      return state.wizardStep > 1 && state.wizardStep < 6
    },
    theWizard (state) {
      return state.wizardStep
    }
  }
})
